import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { axisClasses } from "@mui/x-charts/ChartsAxis";
import { valueFormatter } from "./valueFormat";

export default function CitySales({ datesInRange, staffSalesData }) {
  const chartSetting = {
    height: 400,
    sx: {
      [`.${axisClasses.left} .${axisClasses.label}`]: {
        transform: "translate(-20px, 0)",
      },
    },
  };

  function formatString(input) {
    // Remove trailing underscores, if any
    let cleanedInput = input.replace(/_+$/, '');
  
    // Split the string by underscores and capitalize each word
    let formattedString = cleanedInput
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  
    return formattedString;
  }

  function getUniqueStaffNames(data) {
    const staffNames = new Set(); // Using a Set to automatically handle uniqueness

    data?.forEach((record) => {
      Object.keys(record).forEach((key) => {
        if (key !== "date") {
          // Exclude 'date' key
          staffNames.add(key);
        }
      });
    });

    return Array.from(staffNames); // Convert Set to Array
  }

  return (
    <BarChart
      dataset={staffSalesData}
      xAxis={[{ data: datesInRange, scaleType: "band" }]}
      series={getUniqueStaffNames(staffSalesData).map((val) => ({
        dataKey: val,
        label: formatString(val),
        valueFormatter,
      }))}
      {...chartSetting}
    />
  );
}
